import type { NextApiRequest, NextApiResponse } from 'next'
import type { QliroValidateOrderDeclineResponse, ShippingProviderName } from 'ecosystem'
import { createLogger } from 'shared-utils/utils/logger'
import storefrontApi from 'api/storefront-api'
import { validatePostnordShipping } from './utils'

const logger = createLogger('payment', 'qliro', 'validate')

export interface ValidateOrderOpts {
  orderId: string
  shippingProviderName?: ShippingProviderName
}

export const qliroPaymentProvider = async (
  _req: NextApiRequest,
  res: NextApiResponse<QliroValidateOrderDeclineResponse | void>,
  opts: ValidateOrderOpts
) => {
  // Fetch storefront order for shipping validation
  const { error, data: storefrontOrder } = await storefrontApi.orders.getStorefrontOrder({
    orderNumber: opts.orderId
  })

  if (error || !storefrontOrder) {
    logger.error('Failed to fetch storefront order for validation', {
      orderId: opts.orderId,
      error
    })
    res.status(400).json({
      DeclineReason: 'ORDER_FETCH_FAILED',
      DeclineReasonMessage: 'Could not validate the order. Please try again.'
    })
    return
  }

  // Validate shipping data on the storefront order
  let declineResponse: QliroValidateOrderDeclineResponse | null = null

  switch (opts?.shippingProviderName) {
    case 'POSTNORD':
      declineResponse = validatePostnordShipping(storefrontOrder)
      break
    case 'NSHIFT':
      // todo: add NSHIFT validation
      break
    case 'INGRID':
      // todo: add INGRID validation
      break
    case 'DEFAULT':
    default:
      break
  }

  if (declineResponse) {
    res.status(400).json(declineResponse)
    return
  }

  res.status(200).end()
}
